'use strict';

import imageLoaded from './image-loaded';

export default function imagePhysicalSize() {
    const original = this;
    const clone = new Image();

    return new Promise((resolve, reject) => {
        clone.addEventListener('load', function () {
            resolve({
                naturalWidth: clone.naturalWidth,
                naturalHeight: clone.naturalHeight,
            });
        });
        clone.addEventListener('error', function () {
            reject('image has not loaded', clone);
        });

        // trigger loading
        imageLoaded.call(original) ? load() : original.addEventListener('load', function onLoad() {
            original.removeEventListener('load', onLoad);
            load();
        });

    });

    function load() {
        clone.src = original.currentSrc || original.getAttribute('src');
    }
}

